import { Amplify, Hub } from 'aws-amplify'
import {
  hubSignUp,
  hubSignUpFailure,
  hubResendSignUp,
  hubResendSignUpFailure,
} from '../scripts/auth/sign-up'
import { hubSignInFailure } from '../scripts/auth/sign-in'
import { datadogLogs } from '@datadog/browser-logs'

import {
  hubForgotPassword,
  hubForgotPasswordFailure,
  hubForgotPasswordSubmit,
  hubForgotPasswordSubmitFailure,
} from '../scripts/auth/reset'
import { clearCorruptedAuthState } from '../scripts/auth/clear-state'
import { completeAuthentication } from '../scripts/auth/post-login'
import { initializeOAuthCallback } from '../scripts/auth/oauth-init'

const stage = !Pura?.environment?.production
const loginUrl = stage
  ? `https://staging-pura-scents.myshopify.com/pages/auth-callback`
  : `https://pura.com/pages/auth-callback`

const logoutUrl = stage
  ? `https://staging-pura-scents.myshopify.com/account/logout`
  : `https://pura.com/account/logout`

Amplify.configure({
  Auth: {
    identityPoolId: stage
      ? 'us-east-1:6453fc73-c338-4dc0-88d4-97c3d94560df'
      : 'us-east-1:f277ac0f-2758-4647-9e45-5fb6c5799200',
    region: 'us-east-1',
    userPoolId: stage ? 'us-east-1_gTzleiu29' : 'us-east-1_LaB718hYv',
    userPoolWebClientId: stage
      ? '6n43s10do1victjnk4sg9j7sb4'
      : '4iekubat0jb5iljfbaalsiqf9j',
    mandatorySignIn: false,
    oauth: {
      domain: stage
        ? 'staging-pura.auth.us-east-1.amazoncognito.com'
        : 'auth.pura.co',
      scope: ['openid', 'profile', 'email'],
      redirectSignIn: loginUrl,
      redirectSignOut: logoutUrl,
      clientId: stage
        ? '6n43s10do1victjnk4sg9j7sb4'
        : '4iekubat0jb5iljfbaalsiqf9j',
      responseType: 'code',
    },
    authenticationFlowType: 'USER_SRP_AUTH',
  },
})

initializeOAuthCallback()

Hub.listen('auth', async ({ payload }) => {
  const message = payload?.data?.message
  const event = payload.event
  const data = payload.data

  switch (event) {
    case 'cognitoHostedUI':
    case 'signIn':
      await completeAuthentication(data)
      break

    case 'cognitoHostedUI_failure':
    case 'signIn_failure':
      hubSignInFailure(message || 'Hosted UI sign-in failed')
      break

    case 'signUp':
      hubSignUp()
      break

    case 'signUp_failure':
      hubSignUpFailure(message)
      break

    case 'resendSignUp':
      hubResendSignUp()
      break

    case 'resendSignUp_failure':
      hubResendSignUpFailure()
      break

    case 'forgotPassword':
      hubForgotPassword()
      break

    case 'forgotPassword_failure':
      hubForgotPasswordFailure(message)
      break

    case 'forgotPasswordSubmit':
      hubForgotPasswordSubmit()
      break

    case 'forgotPasswordSubmit_failure':
      hubForgotPasswordSubmitFailure(message)
      break

    case 'customState_failure': {
      let lastAuthUser = null
      try {
        const clientId = stage
          ? '6n43s10do1victjnk4sg9j7sb4'
          : '4iekubat0jb5iljfbaalsiqf9j'
        const lastAuthUserKey = `CognitoIdentityServiceProvider.${clientId}.LastAuthUser`
        lastAuthUser = localStorage.getItem(lastAuthUserKey)

        if (!lastAuthUser) {
          lastAuthUser =
            window.analytics?.user?.()?.anonymousId?.() ||
            localStorage.getItem('ajs_anonymous_id') ||
            'unknown'
        }
      } catch (error) {
        console.error('Failed to get lastAuthUser', error)
        lastAuthUser = 'error'
      }

      datadogLogs.logger.info('Social Login Failed', {
        name: 'social login',
        lastAuthUser,
        timestamp: new Date().toISOString(),
        url: window.location.href,
      })

      clearCorruptedAuthState()

      window.location.href = logoutUrl
      break
    }
    default:
  }
})

import '../scripts/auth/activate'
import '../scripts/auth/check-migration'
import '../scripts/auth/federated-sign-in'
import '../scripts/auth/sign-out'
import '../scripts/auth/data-compliance-forms'
